AFRAME.registerComponent('realistic-starfield', {
    schema: {
        starCount: { type: 'number', default: 1000, min: 0 },
        radius: { type: 'number', default: 200 },
        latitude: { type: 'number', default: 34.099201 },
        longitude: { type: 'number', default: -118.107231 },
        rotationSpeedFactor: { type: 'number', default: 1, min: 0 },
        sizeMultiplier: { type: 'number', default: 1, min: 0.1 }
    },

    init: function () {
        this.scene = this.el.sceneEl.object3D;
        this.rendererSystem = this.el.sceneEl.systems.renderer;

        this.cameraEl = this.el.sceneEl.querySelector('#camera');
        if (!this.cameraEl) {
            console.error('Camera with id="camera" not found!');
            return;
        }
        this.camera = this.cameraEl.object3D;

        this.siderealDay = 86164;
        this.baseRotationSpeed = (2 * Math.PI) / this.siderealDay;
        this.time = 0;
        this.lastRotationUpdate = 0;
        this.rotationUpdateInterval = this.data.rotationSpeedFactor === 1 ? 60 : 1; // 60s if 1, else 1s
        this.hasEnteredVR = false;
        this.isOriented = false;

        this.northStarAxis = new THREE.Vector3();

        this.getGeolocation();
        this.createStars();

        this.el.sceneEl.addEventListener('enter-vr', () => {
            console.log('Entering VR mode - Listener Fired');
            if (this.stars) {
                console.log('Stars exist, attempting to add to scene');
                this.scene = this.el.sceneEl.object3D;
                if (!this.scene.children.includes(this.stars)) {
                    this.scene.add(this.stars);
                    console.log('Stars re-added to scene in VR');
                }
                this.stars.visible = true;
                this.updateInitialOrientation();
                this.hasEnteredVR = true;
                console.log('Stars visible and orientation updated in VR, hasEnteredVR:', this.hasEnteredVR);
            } else {
                console.error('Stars object not yet created on VR entry');
            }
        });

        this.el.sceneEl.addEventListener('exit-vr', () => {
            console.log('Exiting VR mode');
            if (this.stars) {
                this.stars.visible = true;
                this.hasEnteredVR = false;
                console.log('Stars visible after VR exit');
            }
        });
    },

    update: function (oldData) {
        if (this.data.starCount !== oldData.starCount || this.data.sizeMultiplier !== oldData.sizeMultiplier) {
            this.createStars();
        }
        if (this.data.latitude !== oldData.latitude || this.data.longitude !== oldData.longitude) {
            this.updateInitialOrientation();
        }
        if (this.data.rotationSpeedFactor !== oldData.rotationSpeedFactor) {
            this.rotationUpdateInterval = this.data.rotationSpeedFactor === 1 ? 60 : 1;
            console.log('Rotation update interval set to:', this.rotationUpdateInterval, 'seconds');
        }
    },

    tick: function (time, delta) {
        if (!this.stars) {
            console.error('No stars object available in tick!');
            return;
        }

        this.time += delta / 1000;

        if (!this.isOriented || (this.hasEnteredVR && this.time < this.rotationUpdateInterval)) {
            this.updateInitialOrientation();
            this.isOriented = true;
            console.log('Orientation applied:', this.hasEnteredVR ? 'VR entry' : 'Initial');
        }

        if (this.time - this.lastRotationUpdate >= this.rotationUpdateInterval) {
            const effectiveSpeed = this.baseRotationSpeed * this.data.rotationSpeedFactor;
            const angle = effectiveSpeed * (this.time - this.lastRotationUpdate);

            if (this.northStarIndex >= 0) {
                const pos = new THREE.Vector3().fromBufferAttribute(this.stars.geometry.attributes.position, this.northStarIndex);
                const worldPos = pos.applyMatrix4(this.stars.matrixWorld);
                this.northStarAxis.copy(worldPos).normalize();
            }

            this.stars.rotateOnWorldAxis(this.northStarAxis, angle);

            this.lastRotationUpdate = this.time;

            if (this.northStarIndex >= 0) {
                const pos = new THREE.Vector3().fromBufferAttribute(this.stars.geometry.attributes.position, this.northStarIndex);
                const worldPos = pos.applyMatrix4(this.stars.matrixWorld);
                //console.log('North Star World Pos:', worldPos.x.toFixed(2), worldPos.y.toFixed(2), worldPos.z.toFixed(2));
            }

            this.stars.geometry.computeBoundingSphere();
            this.stars.geometry.boundingSphere.radius = this.data.radius * 2;

            const envEl = document.getElementById('vrEnvironment');
            const envData = envEl.components.environment.data;
            const sunPos = new THREE.Vector3(envData.lightPosition.x, envData.lightPosition.y, envData.lightPosition.z).normalize();
            this.updateStarVisibilityAndBrightness(sunPos);

            const cameraDirection = new THREE.Vector3();
            this.camera.getWorldDirection(cameraDirection);
            //console.log('Camera Dir Y:', cameraDirection.y.toFixed(2), 'Stars Visible:', this.stars.visible, 'In Scene:', this.scene.children.includes(this.stars));
        }
    },

    remove: function () {
        if (this.stars) {
            this.scene.remove(this.stars);
            this.stars.material.dispose();
            this.stars.geometry.dispose();
        }
    },

    getGeolocation: function () {
        if ('geolocation' in navigator) {
            navigator.geolocation.getCurrentPosition(
                (position) => {
                    this.data.latitude = position.coords.latitude;
                    this.data.longitude = position.coords.longitude;
                    console.log(`Geolocation: Lat ${this.data.latitude}, Lon ${this.data.longitude}`);
                    this.updateInitialOrientation();
                },
                (error) => {
                    console.warn('Geolocation error:', error.message, 'Using defaults: Lat', this.data.latitude, 'Lon', this.data.longitude);
                },
                { timeout: 10000, maximumAge: 60000 }
            );
        } else {
            console.warn('Geolocation not supported by browser, using defaults: Lat', this.data.latitude, 'Lon', this.data.longitude);
        }
    },

    updateInitialOrientation: function () {
        if (!this.stars) return;

        const now = new Date();
        const jd = this.getJulianDate(now);
        const gmst = this.getGMST(jd);
        const lst = gmst + this.data.longitude / 15;
        const lstRad = (lst % 24) * 15 * Math.PI / 180;

        const latRad = this.data.latitude * Math.PI / 180;
        const polarisDecRad = 89.264109 * Math.PI / 180;
        const polarisRaRad = 2.52975 * 15 * Math.PI / 180;
        const tiltAdjustment = polarisDecRad - latRad;

        this.stars.rotation.set(0, 0, 0);
        this.stars.rotateX(tiltAdjustment);
        this.stars.rotateY(-lstRad + polarisRaRad);

        if (this.northStarIndex >= 0) {
            const pos = new THREE.Vector3().fromBufferAttribute(this.stars.geometry.attributes.position, this.northStarIndex);
            const worldPos = pos.applyMatrix4(this.stars.matrixWorld);
            this.northStarAxis.copy(worldPos).normalize();
            console.log('Initial North Star World Pos after orientation:', worldPos.x.toFixed(2), worldPos.y.toFixed(2), worldPos.z.toFixed(2));
            console.log('Rotation Axis set from Polaris:', this.northStarAxis.x.toFixed(4), this.northStarAxis.y.toFixed(4), this.northStarAxis.z.toFixed(4));
        } else {
            this.northStarAxis.set(0, 1, 0);
            console.warn('Using fallback y-axis for rotation');
        }
    },

    getJulianDate: function (date) {
        const time = date.getTime();
        const jd = time / 86400000 + 2440587.5;
        return jd;
    },

    getGMST: function (jd) {
        const d = jd - 2451545.0;
        const T = d / 36525;
        let gmst = 280.46061837 + 360.98564736629 * d + 0.000387933 * T * T - T * T * T / 38710000;
        gmst = gmst % 360;
        if (gmst < 0) gmst += 360;
        return gmst / 15;
    },

    createStars: function () {
        fetch('/top_2000_stars.json')
            .then(response => {
                if (!response.ok) throw new Error('Network response was not ok: ' + response.status);
                return response.json();
            })
            .then(starData => {
                console.log('Star data loaded, length:', starData.length);
                const maxStars = Math.min(this.data.starCount, starData.length);
                if (maxStars === 0) {
                    console.error('No stars available to render!');
                    return;
                }

                console.log('First 10 stars RA/Dec/Proper:');
                for (let i = 0; i < Math.min(10, starData.length); i++) {
                    console.log(`Star ${i}: RA=${starData[i].ra}, Dec=${starData[i].dec}, Mag=${starData[i].mag}, Proper=${starData[i].proper || 'N/A'}`);
                }

                const geometry = new THREE.BufferGeometry();
                const positions = new Float32Array(maxStars * 3);
                const sizes = new Float32Array(maxStars);
                const colors = new Float32Array(maxStars * 3);
                const baseColors = new Float32Array(maxStars * 3);

                const starsToRender = starData
                    .sort((a, b) => a.mag - b.mag)
                    .slice(0, maxStars);

                const radius = this.data.radius;
                const v = new THREE.Vector3();
                let northStarIndex = -1;

                for (let i = 0; i < starsToRender.length; i++) {
                    const star = starsToRender[i];
                    const raRad = (star.ra * 15 * Math.PI) / 180;
                    const decRad = (star.dec * Math.PI) / 180;

                    v.set(
                        Math.cos(decRad) * Math.sin(raRad),
                        Math.sin(decRad),
                        Math.cos(decRad) * Math.cos(raRad)
                    );
                    v.normalize();
                    v.multiplyScalar(radius);

                    positions[i * 3] = v.x;
                    positions[i * 3 + 1] = v.y;
                    positions[i * 3 + 2] = v.z;

                    if (i < 5) {
                        console.log(`Star ${i}: x=${v.x.toFixed(2)}, y=${v.y.toFixed(2)}, z=${v.z.toFixed(2)}, mag=${star.mag}, ra=${star.ra}, dec=${star.dec}, proper=${star.proper || 'N/A'}`);
                    }

                    const mag = star.mag;
                    let size = Math.max(0.05, 0.3 - mag * 0.05) * this.data.sizeMultiplier;
                    const brightness = Math.max(0.2, 1 - mag * 0.15);

                    if (star.proper === "Polaris") {
                        northStarIndex = i;
                        size = 0.3 * this.data.sizeMultiplier * 2;
                        colors[i * 3] = 1;
                        colors[i * 3 + 1] = 1;
                        colors[i * 3 + 2] = 0;

                        const northStarPos = new THREE.Vector3(positions[i * 3], positions[i * 3 + 1], positions[i * 3 + 2]);
                        console.log('North Star (Polaris) Initial Coordinates:', northStarPos.x.toFixed(2), northStarPos.y.toFixed(2), northStarPos.z.toFixed(2));
                    } else {
                        colors[i * 3] = brightness;
                        colors[i * 3 + 1] = brightness;
                        colors[i * 3 + 2] = brightness;
                    }

                    sizes[i] = size;
                    baseColors[i * 3] = colors[i * 3];
                    baseColors[i * 3 + 1] = colors[i * 3 + 1];
                    baseColors[i * 3 + 2] = colors[i * 3 + 2];
                }

                if (northStarIndex === -1) {
                    console.warn('Warning: Could not locate North Star (Polaris) by proper name in star data! Using y-axis as fallback.');
                } else {
                    console.log('North Star found at index:', northStarIndex);
                }

                geometry.setAttribute('position', new THREE.BufferAttribute(positions, 3));
                geometry.setAttribute('size', new THREE.BufferAttribute(sizes, 1));
                geometry.setAttribute('color', new THREE.BufferAttribute(colors, 3));
                geometry.setDrawRange(0, maxStars);
                geometry.computeBoundingSphere();

                this.baseColors = baseColors;
                this.northStarIndex = northStarIndex;

                const material = new THREE.ShaderMaterial({
                    uniforms: {
                        sunDirection: { value: new THREE.Vector3(0, 0, 0) }
                    },
                    vertexShader: `
              attribute float size;
              attribute vec3 color;
              varying vec3 vColor;
              uniform vec3 sunDirection;
              void main() {
                vColor = color;
                vec4 worldPos = modelMatrix * vec4(position, 1.0);
                float visibility = step(0.0, worldPos.y);
                float dotSun = dot(normalize(position), sunDirection);
                float fade = max(0.0, (dotSun + 0.1) * 2.0);
                gl_PointSize = size * visibility * max(0.0, 1.0 - fade);
                gl_Position = projectionMatrix * modelViewMatrix * vec4(position, 1.0);
              }
            `,
                    fragmentShader: `
              varying vec3 vColor;
              void main() {
                if (length(vColor) < 0.01) discard;
                gl_FragColor = vec4(vColor, 1.0);
              }
            `,
                    depthTest: true,
                    depthWrite: false,
                    transparent: true
                });

                this.stars = new THREE.Points(geometry, material);
                this.stars.frustumCulled = false;
                this.stars.renderOrder = 1000;

                if (this.el.sceneEl.is('loaded')) {
                    this.scene.add(this.stars);
                    console.log('Stars added to scene, count:', maxStars);
                    this.updateInitialOrientation();
                } else {
                    console.warn('Scene not loaded yet, stars added post-load');
                    this.el.sceneEl.addEventListener('loaded', () => {
                        this.scene.add(this.stars);
                        console.log('Stars added to scene after load, count:', maxStars);
                        this.updateInitialOrientation();
                    });
                }
            })
            .catch(error => console.error('Error loading star data:', error));
    },

    updateStarVisibilityAndBrightness: function (sunPos) {
        if (this.stars) {
            this.stars.material.uniforms.sunDirection.value.copy(sunPos);
            this.stars.geometry.attributes.color.needsUpdate = true;
        }
    }
});